import { render, staticRenderFns } from "./casting-calls-messages.vue?vue&type=template&id=71160770&scoped=true&"
import script from "./casting-calls-messages.vue?vue&type=script&lang=ts&"
export * from "./casting-calls-messages.vue?vue&type=script&lang=ts&"
import style0 from "./casting-calls-messages.vue?vue&type=style&index=0&id=71160770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71160770",
  null
  
)

export default component.exports